import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { ProjectState } from 'store/Project/ProjectTypes'

export const setBoMItemFocus: CaseReducer<
  ProjectState,
  PayloadAction<string>
> = (state, action) => {
  state.focusedBomItemId = action.payload
}
